import {
  appendPropagatedParameters,
  addLocaleToPath,
  getCurrentLocale,
} from 'app/history';

// Base path of the "update payment method" page. It is served by a separate
// project behind an nginx reverse proxy (like the new checkout), so links to
// it must be full-page navigations, not client-side react-router transitions.
export const UPDATE_PAYMENT_PATH = '/update-payment';

/**
 * Build the URL to the update payment method page for a reservation. The path
 * carries the currently active locale (e.g. `/en-us/update-payment/<id>`) and
 * any params that must be propagated across pages (`ref`, `wl`, `utm_*`, ...)
 * from the current URL.
 * @param  {string} reservationId
 * @return {string}
 */
export const getUpdatePaymentUrl = (reservationId) => {
  const path = addLocaleToPath(
    `${UPDATE_PAYMENT_PATH}/${reservationId}`,
    getCurrentLocale()
  );
  return appendPropagatedParameters(path);
};
